export default __webpack_public_path__ + "static/media/vestacka-intelegencija.2f18482b.gif";